import axios from 'axios';

const IDEAL_POSTCODES_API_KEY = 'ak_ml9v8fi8cojdt7gP6R9vx3GJEjmBv';

export const postcodeService = {
  async searchAddresses(query, limit = 10) {
    try {
      if (!query || query.trim().length < 2) {
        throw new Error('Query must be at least 2 characters');
      }

      const cleanQuery = query.trim();
      console.log('[postcodeService] Starting search for:', cleanQuery);

      // Try postcode search first
      try {
        console.log('[postcodeService] Attempting postcode autocomplete API...');
        const response = await axios.get(
          'https://api.ideal-postcodes.co.uk/v1/autocomplete/postcode',
          {
            params: {
              query: cleanQuery,
              api_key: IDEAL_POSTCODES_API_KEY,
              limit: limit,
            },
            timeout: 10000,
          }
        );
        console.log('[postcodeService] Postcode search successful:', response.data);
        return response.data;
      } catch (postcodeError) {
        // Fallback to address search if postcode search fails
        console.warn('[postcodeService] Postcode search failed:', postcodeError.message);
        console.log('[postcodeService] Attempting address autocomplete API...');
        
        try {
          const response = await axios.get(
            'https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses',
            {
              params: {
                query: cleanQuery,
                api_key: IDEAL_POSTCODES_API_KEY,
                limit: limit,
              },
              timeout: 10000,
            }
          );
          console.log('[postcodeService] Address search successful:', response.data);
          return response.data;
        } catch (addressError) {
          console.error('[postcodeService] Address search also failed:', addressError.message);
          throw addressError;
        }
      }
    } catch (error) {
      console.error('[postcodeService] Fatal error:', error.message);
      throw error;
    }
  },
};
